<template>
  <div id="contact" class="form__contents">
    <div class="form__inputs">
      <div class="form__texts">
        <h2 class="form__texts-header">Personal information</h2>
        <p class="form__texts-sub-header">Let us know you better.</p>
      </div>
      <!-- NAME -->
      <div
        class="form__group"
        :class="{
          'form__group--error': $v.name.$error,
          'form__group--success': !$v.name.$error && $v.name.$dirty
        }"
      >
        <div class="error" v-if="!$v.name.required && $v.name.$dirty">
          Field is required
        </div>
        <div class="error" v-if="!$v.name.minLength">
          Name must have at least
          {{ $v.name.$params.minLength.min }} letters.
        </div>
        <input
          class="form__input"
          placeholder="First Name"
          v-model.trim="$v.name.$model"
          @keyup="readyToSubmit()"
        />
        <i class="form__icon" v-if="!$v.name.$error">
          <check-icon></check-icon>
        </i>
        <i class="form__icon" v-else>
          <alert-icon></alert-icon>
        </i>
      </div>
      <!-- LAST NAME -->
      <div
        class="form__group"
        :class="{
          'form__group--error': $v.last_name.$error,
          'form__group--success': !$v.last_name.$error && $v.last_name.$dirty
        }"
      >
        <div class="error" v-if="!$v.last_name.required && $v.last_name.$dirty">
          Field is required
        </div>
        <div class="error" v-if="!$v.last_name.minLength">
          Name must have at least
          {{ $v.last_name.$params.minLength.min }} letters.
        </div>
        <input
          class="form__input"
          placeholder="Last Name"
          v-model.trim="$v.last_name.$model"
          @keyup="readyToSubmit()"
        />
        <i class="form__icon" v-if="!$v.last_name.$error">
          <check-icon></check-icon>
        </i>
        <i class="form__icon" v-else>
          <alert-icon></alert-icon>
        </i>
      </div>
      <!-- EMAIL -->
      <div
        class="form__group"
        :class="{
          'form__group--error': $v.email.$error,
          'form__group--success': !$v.email.$error && $v.email.$dirty
        }"
      >
        <div class="error" v-if="!$v.email.required && $v.email.$dirty">
          Field is required
        </div>
        <div class="error" v-if="!$v.email.email">Must be an email</div>
        <input
          class="form__input"
          placeholder="Email"
          v-model.trim="$v.email.$model"
          @keyup="readyToSubmit()"
        />
        <i class="form__icon" v-if="!$v.email.$error">
          <check-icon></check-icon>
        </i>
        <i class="form__icon" v-else>
          <alert-icon></alert-icon>
        </i>
      </div>
      <!-- PHONE -->
      <div
        class="form__group"
        :class="{
          'form__group--error': $v.phone.$error,
          'form__group--success': !$v.phone.$error && $v.phone.$dirty
        }"
      >
        <div class="error" v-if="!$v.phone.required && $v.phone.$dirty">
          Field is required
        </div>
        <div
          class="error"
          v-if="!$v.phone.minLength || !$v.phone.numeric || !$v.phone.maxLength"
        >
          Phone must be only 10 numbers
        </div>
        <input
          class="form__input"
          placeholder="Phone Number"
          v-model.trim="$v.phone.$model"
          @keyup="readyToSubmit()"
        />
        <i class="form__icon" v-if="!$v.phone.$error">
          <check-icon></check-icon>
        </i>
        <i class="form__icon" v-else>
          <alert-icon></alert-icon>
        </i>
      </div>
      <!-- COMPANY -->
      <div
        class="form__group"
        :class="{
          'form__group--error': $v.company.$error,
          'form__group--success': !$v.company.$error && $v.company.$dirty
        }"
      >
        <div class="error" v-if="!$v.company.required && $v.company.$dirty">
          Field is required
        </div>
        <div class="error" v-if="!$v.company.minLength">
          Name must have at least
          {{ $v.company.$params.minLength.min }} letters.
        </div>
        <input
          class="form__input"
          placeholder="Company Name"
          v-model.trim="$v.company.$model"
          @keyup="readyToSubmit()"
        />
        <i class="form__icon" v-if="!$v.company.$error">
          <check-icon></check-icon>
        </i>
        <i class="form__icon" v-else>
          <alert-icon></alert-icon>
        </i>
      </div>
      <!-- Employees -->
      <div
        class="form__group"
        :class="{
          'form__group--error': $v.employees.$error,
          'form__group--success': !$v.employees.$error && $v.employees.$dirty
        }"
      >
        <div class="error" v-if="!$v.employees.required && $v.employees.$dirty">
          Field is required
        </div>
        <div class="error" v-if="!$v.employees.numeric">
          Field only accept numbers
        </div>
        <input
          class="form__input"
          placeholder="Number of Employees"
          v-model.trim="$v.employees.$model"
          @keyup="readyToSubmit()"
        />
        <i class="form__icon" v-if="!$v.employees.$error">
          <check-icon></check-icon>
        </i>
        <i class="form__icon" v-else>
          <alert-icon></alert-icon>
        </i>
      </div>
      <!-- COMMENT -->
      <div
        class="form__group"
        :class="{
          'form__group--error': $v.comment.$error,
          'form__group--success': !$v.comment.$error && $v.comment.$dirty
        }"
      >
        <div class="error" v-if="!$v.comment.required && $v.comment.$dirty">
          Field is required
        </div>
        <input
          class="form__input"
          placeholder="Any Comments?"
          v-model.trim="$v.comment.$model"
          @keyup="readyToSubmit()"
        />
        <i class="form__icon" v-if="!$v.comment.$error">
          <check-icon></check-icon>
        </i>
        <i class="form__icon" v-else>
          <alert-icon></alert-icon>
        </i>
      </div>
    </div>
    <div class="form__options">
      <div class="form__texts">
        <h2 class="form__texts-header">Project type</h2>
        <p class="form__texts-sub-header">Check all that apply.</p>
      </div>
      <form-checkbox @readyToSubmit="readyToSubmit()"></form-checkbox>
    </div>
  </div>
</template>

<script>
import formCheckbox from '../FormSection/FormCheckbox';
import {
  required,
  minLength,
  maxLength,
  email,
  numeric
} from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      name: '',
      last_name: '',
      email: '',
      phone: '',
      company: '',
      employees: '',
      comment: ''
    };
  },
  methods: {
    readyToSubmit() {
      !this.$v.$invalid
        ? this.$emit('readyToSubmit', this.$v)
        : this.$emit('readyToSubmit', false);
    }
  },
  components: {
    formCheckbox
  },
  validations: {
    name: {
      required,
      minLength: minLength(2)
    },
    last_name: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    phone: {
      required,
      numeric,
      minLength: minLength(10),
      maxLength: maxLength(10)
    },
    company: {
      required,
      minLength: minLength(2)
    },
    employees: {
      required,
      numeric
    },
    comment: {
      required
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  &__group {
    position: relative;
    margin-top: 1rem;
    .form__input {
      width: 85%;
      @include mq-max(991px) {
        width: 93%;
        left: 50%;
        transform: translateX(-50%);
      }
      @include mq-max(450px) {
        width: 89%;
      }
    }
  }
  &__texts {
    color: $text-gray;
    font-family: Roboto;
    &-header {
      font-size: 2.4rem;
      font-weight: bold;
      letter-spacing: -0.2rem;
      line-height: 2.8rem;
      margin-bottom: 0.8rem;
      @include mq-max(450px) {
        font-size: 2rem;
      }
    }
    &-sub-header {
      font-size: 1.6rem;
      font-weight: 300;
      letter-spacing: 0;
      line-height: 1.6rem;
      margin-bottom: 1.6rem;
    }
  }
  &__contents {
    display: flex;
    width: 100%;
    @include mq-max(991px) {
      flex-direction: column;
      margin: 0 auto;
    }
  }
  &__inputs {
    padding-right: 2.4rem;
    width: 100%;
    @include mq-max(450px) {
      padding: 0;
    }
  }
  &__options {
    width: 100%;
    @include mq-max(991px) {
      margin-top: 2.5rem;
    }
  }
}
</style>
